import { render, staticRenderFns } from "./OrderServicesList.vue?vue&type=template&id=48ccb8bc"
import script from "./OrderServicesList.vue?vue&type=script&lang=js"
export * from "./OrderServicesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports